import { render, staticRenderFns } from "./ProductFormDialog.vue?vue&type=template&id=5e3a1620&scoped=true"
import script from "./ProductFormDialog.vue?vue&type=script&lang=js"
export * from "./ProductFormDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductFormDialog.vue?vue&type=style&index=0&id=5e3a1620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3a1620",
  null
  
)

export default component.exports